import type { FieldEdge, Field } from '../../types.tsx';

export const transformData = (data: FieldEdge[]): Field[] => data.map((edge) => edge.node);
